import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Flex, Select } from 'antd';

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

import { DATE_FORMAT } from '../../constants/common';

import { setCurrentSelectedDay } from '../../redux/actions/calendar';

import styles from './styles.module.scss';

import { CALENDAR_VIEWS } from '../Calendar/constants';
import PrevNextButtons from '../PrevNextButtons';

dayjs.extend(utc);

function CustomToolbar(props) {
  const dispatch = useDispatch();

  const calendarState = useSelector(state => state.calendar);
  const { currentSelectedDate } = useSelector(state => state.calendar);

  const goToBack = () => {
    const newDate = dayjs(currentSelectedDate).utc().startOf('day');
    let updatedDate;

    switch (props.currentView) {
      case CALENDAR_VIEWS.RESOURCE_WEEK:
        updatedDate = newDate.subtract(1, 'week');
        break;
      case CALENDAR_VIEWS.RESOURCE_MONTH:
        updatedDate = newDate.subtract(1, 'month');
        break;
      case CALENDAR_VIEWS.RESOURCE_YEAR:
        updatedDate = newDate.subtract(1, 'year');
        break;
      default:
        updatedDate = newDate.subtract(1, 'day');
    }

    props.onNavigate?.(updatedDate.toDate(), props.currentView);
    dispatch(setCurrentSelectedDay(updatedDate.toISOString()));
  };

  const goToNext = () => {
    const newDate = dayjs(currentSelectedDate).utc().startOf('day');
    let updatedDate;

    switch (props.currentView) {
      case CALENDAR_VIEWS.RESOURCE_WEEK:
        updatedDate = newDate.add(1, 'week');
        break;
      case CALENDAR_VIEWS.RESOURCE_MONTH:
        updatedDate = newDate.add(1, 'month');
        break;
      case CALENDAR_VIEWS.RESOURCE_YEAR:
        updatedDate = newDate.add(1, 'year');
        break;
      default:
        updatedDate = newDate.add(1, 'day');
    }

    props.onNavigate?.(updatedDate.toDate(), props.currentView);
    dispatch(setCurrentSelectedDay(updatedDate.toISOString()));
  };

  useEffect(() => {
    if (calendarState.prevCount) {
      goToBack();
    }
  }, [calendarState.prevCount]);

  useEffect(() => {
    if (calendarState.nextCount) {
      goToNext();
    }
  }, [calendarState.nextCount]);

  const goToDayView = () => {
    const today = new Date();
    dispatch(setCurrentSelectedDay(props.selectedCalendarDate || today.toISOString()));
    props.onView(CALENDAR_VIEWS.RESOURCE_DAY);
    props.handleViewChange(CALENDAR_VIEWS.RESOURCE_DAY);
  };

  const goToWeekView = () => {
    const today = new Date();
    dispatch(setCurrentSelectedDay(today.toISOString()));
    props.onView(CALENDAR_VIEWS.RESOURCE_WEEK);
    props.handleViewChange(CALENDAR_VIEWS.RESOURCE_WEEK);
  };

  const goToMonthView = () => {
    const today = new Date();
    dispatch(setCurrentSelectedDay(today.toISOString()));
    props.onView(CALENDAR_VIEWS.RESOURCE_MONTH);
    props.handleViewChange(CALENDAR_VIEWS.RESOURCE_MONTH);
  };

  const goToYearView = () => {
    const today = new Date();
    dispatch(setCurrentSelectedDay(today.toISOString()));
    props.onView(CALENDAR_VIEWS.RESOURCE_YEAR);
    props.handleViewChange(CALENDAR_VIEWS.RESOURCE_YEAR);
  };

  const goToToday = () => {
    const today = new Date();
    dispatch(setCurrentSelectedDay(today.toISOString()));
    props.date?.setMonth(today.getMonth());
    props.date?.setYear(today.getFullYear());
    props.date?.setDate(today.getDate());
    props.onNavigate?.(today);
  };

  const month = () => {
    const date = dayjs(currentSelectedDate);

    return <p className={styles.month}>{date.format(DATE_FORMAT.DATE_MONTH_YEAR)}</p>;
  };

  const handleChange = value => {
    props.handleViewChange(value === 'today' ? CALENDAR_VIEWS.RESOURCE_DAY : value);
    switch (value) {
      case 'today':
        return goToToday();
      case CALENDAR_VIEWS.RESOURCE_DAY:
        return goToDayView();
      case CALENDAR_VIEWS.RESOURCE_WEEK:
        return goToWeekView();
      case CALENDAR_VIEWS.RESOURCE_MONTH:
        return goToMonthView();
      case CALENDAR_VIEWS.RESOURCE_YEAR:
        return goToYearView();
      default:
        return;
    }
  };

  const options = [
    {
      label: 'Today',
      value: 'today',
      disabled: dayjs(currentSelectedDate).isSame(dayjs(), 'day')
    },
    {
      label: 'Day',
      value: CALENDAR_VIEWS.RESOURCE_DAY
    },
    {
      label: 'Week',
      value: CALENDAR_VIEWS.RESOURCE_WEEK
    },
    {
      label: 'Month',
      value: CALENDAR_VIEWS.RESOURCE_MONTH
    }
  ];

  return (
    <Flex align="center" justify="space-between" gap="small" className="mb-2 w-full" wrap>
      {month()}

      <Flex gap="small">
        <Select
          className="calendar-select"
          size="large"
          defaultValue={props.currentView ?? CALENDAR_VIEWS.RESOURCE_WEEK}
          options={props.options ?? options}
          onChange={handleChange}
        />
        <PrevNextButtons nextId={true} prevId={true} handlePrev={goToBack} handleNext={goToNext} />
      </Flex>
    </Flex>
  );
}

export default CustomToolbar;
